import { AxiosInstance } from 'axios';
import getCodeServices from './code';
import getContactServices from './contact';
import activityServices from './activity';
import getContentServices from './content';
import getUserServices from './user';
import getDownloadService from './download';
import recommendService from './recommend';

type CommonServices = {
  code: ReturnType<typeof getCodeServices>;
  contact: ReturnType<typeof getContactServices>;
  activity: ReturnType<typeof activityServices>;
  content: ReturnType<typeof getContentServices>;
  user: ReturnType<typeof getUserServices>;
  download: ReturnType<typeof getDownloadService>;
  recommend: ReturnType<typeof recommendService>;
};

let commonServices: {
  current: CommonServices | null;
} = { current: null };

export function createPortalService({
  GateWayInstance,
  OfficialGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  OfficialGateWayInstance: AxiosInstance;
  LoginGateWayInstance?: AxiosInstance;
}) {
  if (commonServices.current) return commonServices.current;
  commonServices.current = {
    user: getUserServices({ GateWayInstance, OfficialGateWayInstance }),
    code: getCodeServices({
      GateWayInstance,
    }),
    contact: getContactServices({
      OfficialGateWayInstance,
    }),
    activity: activityServices({ GateWayInstance, OfficialGateWayInstance }),
    content: getContentServices({ OfficialGateWayInstance }),
    download: getDownloadService({ GateWayInstance }),
    recommend: recommendService({ GateWayInstance, OfficialGateWayInstance }),
  };
  return commonServices.current;
}

export default commonServices;
